/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui';
import React from 'react';
import { Box } from 'theme-ui';
import { Text } from '@theme-ui/components';
import ReCAPTCHA from 'react-google-recaptcha';
import { useBreakpointIndex } from '@theme-ui/match-media';

const recaptchaRef = React.createRef();

const FormRecaptcha = ({ errors, onChange }) => {
	const bp = useBreakpointIndex({ defaultIndex: 2 })
	const size = bp < 2 ? "compact" : "normal";
	return (
		<Box sx={{ mb: 3 }}>
			<ReCAPTCHA
				ref={recaptchaRef}
				sitekey={process.env.GATSBY_RE_CAPTCHA_SITE_KEY}
				onChange={onChange}
				size={size}
			/>
			<Box sx={{ textAlign: 'center', color: 'red', my: 2 }}>
				{errors && errors.captcha ? <Text>{errors.captcha}</Text> : null}
			</Box>
		</Box>
	);
};

export default FormRecaptcha;
